module.exports = __webpack_public_path__ + "static/media/KenzieProfiles.3ab6fa1d.png";